import { SceneNode } from '@/features/screenplay/components/editor/nodes/SceneNode'
import { Shot } from '@/features/shotlist'
import { create } from 'zustand'

export interface StoryboardStoreState {
    selectedSceneNode: SceneNode | null
    selectScene: (sceneNode: SceneNode | null) => void
    selectedShot: Shot | null
    selectShot: (shot: Shot | null) => void
}

export const useStoryboardStore = create<StoryboardStoreState>((set) => ({
    selectedSceneNode: null,
    selectedShot: null,
    selectScene: (sceneNode) => {
        set({ selectedSceneNode: sceneNode })
    },
    selectShot: (shot) => {
        set({ selectedShot: shot })
    }
}))
